<template>
    <Head title="Change Shift"></Head>
    <div class="grid">
        <div class="col-12">
            <div class="card">
                <Toast />
                <DataTable
                    ref="dt"
                    :value="models"
                    :lazy="true"
                    dataKey="id"
                    v-model:selection="selectedModels"
                    :paginator="true"
                    :rows="10"
                    :loading="loading"
                    :total-records="totalRecords"
                    v-model:filters="filters"
                    paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                    :rowsPerPageOptions="[5, 10, 25]"
                    currentPageReportTemplate="Showing {first} to {last} of {totalRecords} models"
                    responsiveLayout="scroll"
                    @row-select="onRowSelect"
                    @row-unselect="onRowUnselect"
                    @page="onPage($event)"
                    @sort="onSort($event)"
                >
                    <template #header>
                        <div
                            class="flex flex-column md:flex-row md:justify-content-between md:align-items-center"
                        >
                            <h5 class="m-0">Tukar Shift</h5>
                            <span class="block mt-2 md:mt-0 p-input-icon-left">
                                <i class="pi pi-search" />
                                <InputText
                                    @change="onFilter($event)"
                                    v-model="filters['global'].value"
                                    placeholder="Search..."
                                />
                            </span>
                        </div>
                    </template>

                    <Column
                        selectionMode="single"
                    ></Column>
                    <Column
                        field="id"
                        header="id"
                        :sortable="true"
                        headerStyle="width:1%;"
                    >
                        <template #body="slotProps">
                            <span class="p-column-title">Id</span>
                            {{ slotProps.data.id }}
                        </template>
                    </Column>
                    <Column
                        field="from_date"
                        header="Dari Tanggal"
                        headerStyle="width:20%;"
                    >
                        <template #body="slotProps">
                            {{ slotProps.data.from_date }}
                        </template>
                    </Column>
                    <Column
                        field="to_date"
                        header="Ke Tanggal"
                        headerStyle="width:20%;"
                    >
                        <template #body="slotProps">
                            {{ slotProps.data.to_date }}
                        </template>
                    </Column>
                    <Column
                        field="reasons"
                        header="Alasan"
                        headerStyle="width:20%;"
                    >
                        <template #body="slotProps">
                            {{ slotProps.data.reasons }}
                        </template>
                    </Column>
                    <Column
                        field="prove_reason"
                        header="Bukti"
                        headerStyle="width:20%;"
                    >
                        <template #body="slotProps">
                            <Image v-if="(slotProps.data.prove_reason != 'none' || !slotProps.data.prove_reason)" :src="slotProps.data.prove_reason" preview="true" width="100" class="mb-2" />
                        </template>
                    </Column>
                    <Column
                        field="creating_user"
                        header="Peminta"
                        headerStyle="width:20%;"
                    >
                        <template #body="slotProps">
                            {{ slotProps.data.creating_user }}
                        </template>
                    </Column>
                    <Column
                        field="replacing_user"
                        header="Pengganti"
                        headerStyle="width:20%;"
                    >
                        <template #body="slotProps">
                            {{ slotProps.data.replacing_user }}
                        </template>
                    </Column>
                    <Column header="Aksi" headerStyle="width:20%;min-width:10rem;">
                        <template #body="slotProps">
                            <div v-if="slotProps.data.approved_at">
                                Permohonan sudah disetujui pada tanggal : {{ slotProps.data.approved_at }}
                            </div>
                            <div v-else>
                                <Button
                                    v-tooltip.top="'Terima Permintaan'"
                                    icon="pi pi-check"
                                    class="mr-2 p-button-success"
                                    @click="approveModel(slotProps.data.id)"
                                />
                            </div>
                        </template>
                    </Column>
                </DataTable>
            </div>
        </div>
    </div>

    <Dialog
        v-model:visible="modelDialog"
        :style="{ width: '450px' }"
        header="Permohonan Tukar Shift"
        :modal="true"
        class="p-fluid"
    >
        <div class="field">
            <label for="name">Tanggal Shift Yang Ingin Ditukar</label>
            <Dropdown v-model="mappingShift" :options="mappingShifts" optionLabel="tanggal" placeholder="Pilih Shift" />
            <small class="p-invalid" v-if="submitted && !mappingShift"
                >Shift is required.</small
            >
        </div>
        <div class="field">
            <label for="name">Tukar Dengan Tanggal</label>
            <Dropdown v-model="targetMappingShift" :options="targetMappingShifts" optionLabel="tanggal" placeholder="Pilih Target Shift" @change="loadEmployees" />
            <small class="p-invalid" v-if="submitted && !targetMappingShift"
                >Target Shift is required.</small
            >
        </div>
        <div class="field">
            <label for="name">Nama Karyawan</label>
            <Dropdown v-model="employee" :options="employees" optionLabel="name" placeholder="Pilih Shift" />
            <small class="p-invalid" v-if="submitted && !employee"
                >Shift is required.</small
            >
        </div>
        <div class="field">
            <label for="name">Alasan Tukar</label>
            <Textarea id="address" rows="4" v-model="reasons" :class="{ 'p-invalid': submitted && !form.reasons }" />
            <small class="p-invalid" v-if="submitted && !reasons"
                >Shift is required.</small
            >
        </div>
        <div class="field">
            <label for="name">Upload Bukti</label>
            <FileUpload mode="basic" name="foto[]" :maxFileSize="3000000" @select="onUpload" chooseLabel="Ganti Foto"/>
            <small class="p-invalid" v-if="submitted && !model.shift"
                >Shift is required.</small
            >
        </div>

        <template #footer>
            <Button
                label="Cancel"
                icon="pi pi-times"
                class="p-button-text"
                @click="modelDialog = false"
            />
            <Button
                label="Save"
                icon="pi pi-check"
                class="p-button-text"
                @click="saveModel"
            />
        </template>
    </Dialog>
</template>

<script>
import AppLayout from "../../Layouts/AppLayout";
import { FilterMatchMode } from "primevue/api";
import { Head } from "@inertiajs/inertia-vue3";
import Button from "primevue/button";
import InputText from "primevue/inputtext";
import Image from 'primevue/image';
import Toolbar from "primevue/toolbar";
import Toast from "primevue/toast";
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import Dropdown from "primevue/dropdown";
import Dialog from "primevue/dialog";
import DatatableService from "../../Services/DatatableService";
import FlashMessage from "../../Services/FlashMessage";
import FileUpload from "primevue/fileupload";
import Textarea from 'primevue/textarea';
import axios from "axios";

export default {
    name: "Index",
    layout: AppLayout,
    components: {
        Head,
        Button,
        InputText,
        Toolbar,
        Toast,
        DataTable,
        Column,
        Dropdown,
        Dialog,
        Textarea,
        FileUpload,
        Image,
    },
    mixins: [FlashMessage],
    data() {
        return {
            searchFilter: "",
            filters: {},
            lazyParams: {},
            loading: true,
            totalRecords: 0,
            selectedModel: null,
            model: {},
            models: null,
            selectedModels: null,
            submitted: false,
            selectAll: false,
            isExporting: false,
            deleteModelDialog: false,
            modelDialog: false,
        };
    },
    datatableService: null,
    created() {
        this.datatableService = new DatatableService();
        this.initFilters();
    },
    mounted() {
        this.loading = true;
        this.lazyParams = {
            first: 0,
            rows: this.$refs.dt.rows,
            sortField: "id",
            sortOrder: -1,
            filters: this.filters,
        };
        this.loadLazyData();
    },
    methods: {
        loadLazyData() {
            this.loading = true;
            this.datatableService
                .getData(`${this.$page.props.appUrl}api/admin/change-shifts/datatable`, this.lazyParams)
                .then((data) => {
                    this.models = data.data;
                    this.totalRecords = data.total;
                    this.loading = false;
                });
        },
        approveModel(id){
            axios.post(`${this.$page.props.appUrl}api/admin/change-shifts/${id}/approve`)
            .then((data) => {
                this.flashSuccess("Permohonan Berhasil Disetujui");
                this.loadLazyData();
            })
            .catch((error) => {
                this.flashError(error.response.data.message);
            });
        },
        deleteModel() {
            axios
                .delete(`${this.$page.props.appUrl}api/user/change-shifts/${this.model.id}`)
                .then((response) => {
                    this.flashSuccess("Permohonan Berhasil Dihapus")
                    this.deleteModelDialog = false;
                    this.model = {};
                    this.loadLazyData();
                })
                .catch((error) => {
                    this.flashError("Permohonan Gagal Dihapus " + error)
                });
        },
        onRowSelect() {
            this.selectAll = this.selectedModels.length === this.totalRecord;
        },
        onRowUnselect() {
            this.selectAll = false;
        },
        onPage(event) {
            this.lazyParams = event;
            this.loadLazyData();
        },
        onSort(event) {
            this.lazyParams = event;
            this.loadLazyData();
        },
        onFilter(event) {
            this.loadLazyData();
        },
        initFilters() {
            this.filters = {
                global: { value: null, matchMode: FilterMatchMode.CONTAINS, field: 'id' },
            };
        },
    },
};
</script>
<style scoped lang="scss">
@import "../../../assets/demo/badges.scss";
</style>
